import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { getAdjacentMonth } from '../../utils/calendar.utils';
type CalendarHeaderProps = {
    date: Date;
    onDateChange: (date: Date) => void;
    onMonthYearClick: () => void;
};

export default function CalendarHeader({
    date,
    onDateChange,
    onMonthYearClick,
}: CalendarHeaderProps) {
    const handleOnDateChange = (direction: boolean) => {
        onDateChange(getAdjacentMonth(date, direction));
    };

    return (
        <div className="alli-flex alli-items-center alli-text-gray-900">
            <button
                type="button"
                data-testid="previous-month-button"
                onClick={() => handleOnDateChange(false)}
                className="alli-text-primary hover:text-gray-500 alli--m-1.5 alli-flex alli-flex-none alli-items-center alli-justify-center alli-p-1.5">
                <span className="alli-sr-only">Previous month</span>
                <ChevronLeftIcon className="alli-size-5" aria-hidden="true" />
            </button>
            <button
                type="button"
                data-testid="month-year-button"
                onClick={onMonthYearClick}
                className="alli-flex-auto alli-text-center alli-text-sm alli-font-semibold">
                {`${date.toLocaleString('default', {
                    month: 'long',
                })} ${date.getFullYear()}`}
            </button>
            <button
                type="button"
                data-testid="next-month-button"
                onClick={() => handleOnDateChange(true)}
                className="alli- text-primary hover:text-gray-500 alli--m-1.5 alli-flex alli-flex-none alli-items-center
                alli-justify-center alli-p-1.5">
                <span className="alli-sr-only">Next month</span>
                <ChevronRightIcon className="alli-size-5" aria-hidden="true" />
            </button>
        </div>
    );
}
